import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExpandAlt, faCompressAlt } from "@fortawesome/free-solid-svg-icons";
import { actions as appActions } from "../../actions/app";
import { getAxisUserProfile } from "../../actions/auth";
import { actions as axisOrdersActions } from "../../actions/axisOrders";
import DeliveryStatusTable from "./DeliveryStatusTable";
import {
  Table,
  TableHeader,
  TableRow,
  TableHeaderCell,
} from "../../styled-components/Table";
import { IconButton } from "../../styled-components";
import Constants from "../../constants/deliveryStatusTable";
import OrderStatus from "./OrderStatus";
import MapStatus from "./MapStatus";
import LuciPropTypes from "../../propTypes/";
import AppSettings from "../../settings";
import SideBarState from "../../constants/sidebarState";
import ViewPortSize from "../../constants/viewPortSize";
import App from "../../constants/app";
import { localizeAxis as localize } from "../../util/localizeUtils";

const DeliveryStatusContainer = styled.div`
  height: 5rem;
  background-color: ${(props) => props.theme.table.background};
`;

const TableContainer = styled.div`
  height: 3.75rem;
  overflow-y: scroll;
`;

const HeaderContainer = styled.div`
  background-color: ${(props) => props.theme.table.header};
`;

const HeaderCellButton = styled.button`
  white-space: nowrap;
`;

const HeaderImg = styled.img`
  height: 0.9rem;
`;

const Icon = styled.img`
  margin-right: 0.25rem;
  height: 0.9rem;
`;

let deliveryStatusWorker = null;

const NeedsApprovalIcon = (
  <Icon
    src="images/thumbup.png"
    alt={localize("needsApprovalTooltip")}
    title={localize("needsApprovalTooltip")}
  />
);

class DeliveryStatus extends Component {
  constructor() {
    super();

    this.state = {
      ordersVisible: false,
      mapsVisible: false,
    };
  }

  componentDidMount() {
    this.props.changeFooterHeight("5rem");
  }

  UNSAFE_componentWillMount() {
    if (this.props.loggedIntoAxis) {
      this.getFeed();
    }
  }

  UNSAFE_componentWillUpdate(nextProps) {
    if (!nextProps.axisServicesLoaded) {
      nextProps.getAxisUserProfile();
    }
    if (!nextProps.loggedIntoAxis) {
      clearTimeout(deliveryStatusWorker);
    } else if (!this.props.loggedIntoAxis) {
      this.getFeed();
    }
  }

  componentWillUnmount() {
    clearTimeout(deliveryStatusWorker);
  }

  getFeed = () => {
    if (!this.props.deliveryFeedLoading && this.props.initialized) {
      this.props.getDeliveryFeed();
    }
    deliveryStatusWorker = setTimeout(
      () => this.getFeed(),
      AppSettings.feedPollingRate
    );
  };

  getLeftSize = () => {
    const { sidebar, viewPortSize } = this.props;
    if (sidebar === SideBarState.LEFT_ONLY || sidebar === SideBarState.BOTH) {
      if (viewPortSize < ViewPortSize.LARGE) {
        return App.SIDEBAR_MIN_WIDTH;
      }
      return App.SIDEBAR_WIDTH;
    }
    return "0rem";
  };

  toggleMaps = () => {
    this.setState({
      mapsVisible: !this.state.mapsVisible,
    });
  };

  toggleOrders = () => {
    this.setState({
      ordersVisible: !this.state.ordersVisible,
    });
  };

  render() {
    if (this.props.axisServicesLoaded && !this.props.loggedIntoAxis) {
      return null;
    }

    return (
      <div>
        <OrderStatus
          left={this.getLeftSize()}
          visible={this.state.ordersVisible}
          close={this.toggleOrders}
        />
        <MapStatus
          left={this.getLeftSize()}
          visible={this.state.mapsVisible}
          close={this.toggleMaps}
        />
        <DeliveryStatusContainer>
          <HeaderContainer>
            <Table width="100%">
              <TableHeader>
                <TableRow>
                  <TableHeaderCell
                    width={Constants.DELIVERY_STATUS_COLUMN_WIDTH}
                  >
                    {localize("deliveryStatusHeader")}
                  </TableHeaderCell>
                  <TableHeaderCell width={Constants.MAPS_COLUMN_WIDTH} bold>
                    <TableHeaderCell>
                      {localize("mapsHeader")}{" "}
                      {/* <HeaderImg src="images/expand.png" />*/}
                    </TableHeaderCell>
                  </TableHeaderCell>
                  <TableHeaderCell width={Constants.ORDER_COLUMN_WIDTH} bold>
                    <HeaderCellButton onClick={this.toggleOrders}>
                      {this.props.hasOrdersNeedingApproval
                        ? NeedsApprovalIcon
                        : ""}
                      {localize("orderHeader")}{" "}
                      <FontAwesomeIcon
                        fixedWidth
                        size="lg"
                        icon={
                          this.state.ordersVisible ? faCompressAlt : faExpandAlt
                        }
                      />
                    </HeaderCellButton>
                  </TableHeaderCell>
                </TableRow>
              </TableHeader>
            </Table>
          </HeaderContainer>
          <TableContainer>
            <DeliveryStatusTable deliveryFeed={this.props.deliveryFeed} />
          </TableContainer>
        </DeliveryStatusContainer>
      </div>
    );
  }
}

DeliveryStatus.propTypes = {
  getAxisUserProfile: PropTypes.func.isRequired,
  deliveryFeed: PropTypes.arrayOf(LuciPropTypes.AxisDeliveryFeed).isRequired,
  getDeliveryFeed: PropTypes.func.isRequired,
  deliveryFeedLoading: PropTypes.bool.isRequired,
  axisServicesLoaded: PropTypes.bool.isRequired,
  loggedIntoAxis: PropTypes.bool.isRequired,
  hasOrdersNeedingApproval: PropTypes.bool.isRequired,
  changeFooterHeight: PropTypes.func.isRequired,
  sidebar: PropTypes.string.isRequired,
  viewPortSize: PropTypes.number.isRequired,
  initialized: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => ({
  deliveryFeed: state.axisOrders.deliveryFeed,
  deliveryFeedLoading: state.axisOrders.deliveryFeedLoading,
  hasOrdersNeedingApproval: state.axisOrders.orders
    ? state.axisOrders.orders.some((o) => o.approvalRequested)
    : false,
  axisServicesLoaded: state.auth.axisUserProfile.loaded,
  loggedIntoAxis: state.auth.axisUserProfile.services.length > 0,
  viewPortSize: state.app.viewPortSize,
  sidebar: state.app.sidebar,
  initialized: state.app.initialized,
});

const mapActionCreators = {
  getAxisUserProfile,
  getDeliveryFeed: axisOrdersActions.getDeliveryFeed,
  getMapStatus: axisOrdersActions.getMapStatus,
  getOrderStatus: axisOrdersActions.getOrderStatus,
  changeFooterHeight: appActions.changeFooterHeight,
};

export default connect(mapStateToProps, mapActionCreators)(DeliveryStatus);



// WEBPACK FOOTER //
// ./app/components/DeliveryStatus/DeliveryStatus.js